import React from 'react';

/**
 * MatchScoreBar - Visual representation of match score percentage
 *
 * Props:
 * - score: Number between 0-100
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - showLabel: boolean (default: true)
 */
const MatchScoreBar = ({ score, size = 'md', showLabel = true }) => {
  const getColorClass = (score) => {
    if (score >= 80) return 'bg-green-500';
    if (score >= 60) return 'bg-blue-500';
    if (score >= 40) return 'bg-yellow-500';
    return 'bg-red-500';
  };

  const getTextColorClass = (score) => {
    if (score >= 80) return 'text-green-700 dark:text-green-400';
    if (score >= 60) return 'text-blue-700 dark:text-blue-400';
    if (score >= 40) return 'text-yellow-700 dark:text-yellow-400';
    return 'text-red-700 dark:text-red-400';
  };

  const heightClass = {
    sm: 'h-1.5',
    md: 'h-2',
    lg: 'h-3'
  }[size];

  const textClass = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  }[size];

  const clampedScore = Math.max(0, Math.min(100, score));

  return (
    <div className="flex items-center space-x-2">
      <div className={`flex-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden ${heightClass}`}>
        <div
          className={`${heightClass} ${getColorClass(clampedScore)} transition-all duration-300`}
          style={{ width: `${clampedScore}%` }}
        />
      </div>
      {showLabel && (
        <span className={`font-medium ${textClass} ${getTextColorClass(clampedScore)} min-w-[3rem] text-right`}>
          {clampedScore}%
        </span>
      )}
    </div>
  );
};

export default MatchScoreBar;
